// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2q8Lw","label":"Labeled_label__3lZnu","divider":"Labeled_divider__2i-JK"};